import {
  AfterViewInit,
  Directive,
  DOCUMENT,
  ElementRef,
  inject,
  NgZone,
  OnDestroy,
} from '@angular/core';

import { TooltipDirective } from './tooltip.directive';

@Directive({
  selector: '[b2cTooltipIfTruncated]',
})
export class TooltipIfTruncatedDirective implements AfterViewInit, OnDestroy {
  private resizeObserver?: ResizeObserver;

  private update = () => {
    const el = this.host.nativeElement;
    const truncated =
      el.textContent.includes('…') || el.scrollWidth > el.clientWidth;
    if (this.tooltip) this.tooltip.isTooltipDisabled.set(!truncated);
  };

  private zone: NgZone = inject(NgZone);
  private document: Document = inject(DOCUMENT);
  private host: ElementRef<HTMLElement> = inject(ElementRef);
  private tooltip: TooltipDirective = inject(TooltipDirective);

  ngAfterViewInit() {
    this.checkWhenResized();
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
    this.document.defaultView?.removeEventListener('resize', this.update);
  }

  private checkWhenResized(): void {
    this.zone.runOutsideAngular(() => {
      this.update();
      // Check if ResizeObserver is available (not available in SSR)
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.host.nativeElement);
      }
      this.document.defaultView?.addEventListener('resize', this.update);
    });
  }
}
